import { deleteNarratives, updateNarrativeName } from '@api/narratives';
import { updateFlowState } from '@api/narrative-projects';

export const renameRunNarrative = ({ flowId, name }) => updateNarrativeName({ id: flowId, name });

export const deleteRunNarrative = async ({
  chatSessionId,
  flowId,
  shouldClearFlowState = false,
}) => {
  await deleteNarratives({ ids: [flowId] });

  if (!shouldClearFlowState) {
    return { hasFlowStateCleanupError: false };
  }

  try {
    await updateFlowState({
      chatSessionId,
      flowState: {
        editablePromptAnswers: {},
        narrativeName: '',
        topics: [],
      },
    });
    return { hasFlowStateCleanupError: false };
  } catch (error) {
    console.error('Failed to clear deleted narrative flow state', error);
    return { hasFlowStateCleanupError: true };
  }
};
